<template>
    <div>
        <div v-if="isLoading" class="item-spinner d-flex justify-content-center">
            <ob1-progress-indicators :size="50" type="undetermined" />
        </div>
        <div v-else id="addAccessoryCta" class="pt-1">
            <ob1-boutons
                ref="add-accessory-cta"
                :label="accessory.currentVersion.boutonsDTO.label"
                :is-primary="true"
                :is-disabled="!isAddButtonEnabled"
                @ob1-boutons-click="onAddAccessoryButtonClick"
            />
        </div>

        <ob1-popin-modal2
            :id="accessory.addToCartDTO.popinModalDTO.id"
            :aria-labelledby="accessory.addToCartDTO.popinModalDTO.label"
            :show-close-button="false"
        >
            <h3 class="h4">
                {{ accessory.addToCartDTO.popinTitle }}
            </h3>
            <div class="d-flex justify-content-center justify-content-md-start">
                <div class="d-flex flex-column">
                    <ob1-boutons
                        data-bs-dismiss="modal"
                        :label="accessory.addToCartDTO.continueShopping"
                        :is-secondary="true"
                        class="my-2"
                    />

                    <ob1-boutons
                        :label="accessory.addToCartDTO.liensDTO.text"
                        :href="cartUrl"
                        :is-button="false"
                        :is-primary="true"
                    />
                </div>
            </div>
        </ob1-popin-modal2>
    </div>
</template>

<script>

export default {
    props: {
        accessory: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isAddButtonEnabled: {
            type: Boolean,
            required: true
        },
        cartUrl: {
            type: String,
            default: undefined
        }
    },
    methods: {
        onAddAccessoryButtonClick(event) {
            this.$emit('accessory-cta-click', event);
        }
    }
}
</script>
